import { BrowserRouter, Route, Routes } from "react-router-dom";
import { Toaster } from "./components/Toaster";
import { useEffect } from "react";
import axios from "axios";
import { analytics, firestore } from "./firebase";
import { collection, addDoc, updateDoc, setDoc, doc, increment, getDoc } from "firebase/firestore";
import { generateGUID } from "./lib/utils";
import { logEvent } from "firebase/analytics";
import GrammifyPPPage from "./pages/GrammifyPPPage";
import HomePage from "./pages/HomePage";
import LoginPage from "./pages/admin/LoginPage";
import VisitorsPage from "./pages/admin/VisitorsPage";
import DashboardPage from "./pages/admin/DashboardPage";
import ContactFormsPage from "./pages/admin/ContactFormsPage";
import ProtectedRoute from "./components/ProtectedRoute";
import { AuthProvider } from "./contexts/AuthContext";
import CustomerDataPage from "./pages/admin/CustomerDataPage";
import DekaLandPPPage from "./pages/DekaLandPPPage";
import DeleteMyDataPage from "./pages/DeleteMyDataPage";
import GravityAppPPPage from "./pages/GravityAppPPPage";
import SidekickPPPage from "./pages/SidekickPPPage";
import SidekickToUPage from "./pages/SidekickToUPage";

type Props = {};

const App = (props: Props) => {
	useEffect(() => {
		let deviceId = localStorage.getItem("sftdvcid");
		if (!deviceId) {
			deviceId = generateGUID();
			logEvent(analytics, "app_visited", { deviceId });
			localStorage.setItem("sftdvcid", deviceId);
			navigator.geolocation.getCurrentPosition(
				async (success) => {
					const locationResult = await axios.get(
						`https://nominatim.openstreetmap.org/reverse?lat=${success.coords.latitude}&lon=${success.coords.longitude}&format=json`
					);
					const documentData = {
						...locationResult.data,
						createdAt: new Date().toISOString(),
						lastVisit: new Date().toISOString(),
						visitCount: 1,
						success: true,
						language: navigator.language,
						deviceId,
					};
					await setDoc(doc(firestore, "visiters", deviceId as any), documentData);
				},
				async (error) => {
					const visitersCollection = collection(firestore, "visiters"); // Firestore collection
					const documentData = {
						...error,
						createdAt: new Date().toISOString(),
						lastVisit: new Date().toISOString(),
						visitCount: 1,
						success: false,
						language: navigator.language,
						deviceId,
					};
					await addDoc(visitersCollection, documentData);
				}
			);
		} else {
			(async () => {
				try {
					logEvent(analytics, "app_visited", { deviceId });
					const isExist = await getDoc(doc(firestore, "visiters", deviceId));

					if (isExist.data()) {
						await updateDoc(doc(firestore, "visiters", deviceId), {
							lastVisit: new Date().toISOString(),
							visitCount: increment(+1),
						});
					}
				} catch (error) {}
			})();
		}
	}, []);

	return (
		<AuthProvider>
			<BrowserRouter>
				<Toaster />
				<Routes>
					{/* Public routes */}
					<Route path='/' Component={HomePage} />
					<Route path='/apps/grammify/privacy-policy' Component={GrammifyPPPage} />
					<Route path='/apps/dekaland/privacy-policy' Component={DekaLandPPPage} />
					<Route path='/apps/dekaland/delete-my-data' Component={DeleteMyDataPage} />
					<Route path='/apps/gravity-flip-courier/privacy-policy' Component={GravityAppPPPage} />
					<Route path='/apps/sidekick/privacy-policy' Component={SidekickPPPage} />
					<Route path='/apps/sidekick/terms-of-use' Component={SidekickToUPage} />

					<Route path='/admin/login' Component={LoginPage} />

					{/* Protected admin routes */}
					<Route
						path='/admin'
						element={
							<ProtectedRoute>
								<DashboardPage />
							</ProtectedRoute>
						}
					/>
					<Route
						path='/admin/visitors'
						element={
							<ProtectedRoute>
								<VisitorsPage />
							</ProtectedRoute>
						}
					/>
					<Route
						path='/admin/contact-forms'
						element={
							<ProtectedRoute>
								<ContactFormsPage />
							</ProtectedRoute>
						}
					/>
					<Route
						path='/admin/customer-data'
						element={
							<ProtectedRoute>
								<CustomerDataPage />
							</ProtectedRoute>
						}
					/>
				</Routes>
			</BrowserRouter>
		</AuthProvider>
	);
};

export default App;
